// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const left = 500;
// const word = 20; // Adjust the word variable to control the space between links

// function NavBar({ isAdmin, onLogout, isLoggedIn }) {
//   const [scrolled, setScrolled] = useState(false);
//   const [isNavbarOpen, setIsNavbarOpen] = useState(false);

//   const handleScroll = () => {
//     const isScrolled = window.scrollY > 100;
//     setScrolled(isScrolled);
//   };

//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   const handleNavbarToggle = () => {
//     setIsNavbarOpen(!isNavbarOpen);
//   };

//   const closeNavbar = () => {
//     setIsNavbarOpen(false);
//   };
//   const [showLogoutToast, setShowLogoutToast] = useState(false);

//   useEffect(() => {
//     // Check if user is logged in from sessionStorage
//     const userLoggedIn = sessionStorage.getItem('isLoggedIn');
//     if (userLoggedIn === 'true') {
//       // Set isLoggedIn prop if user is logged in
//       isLoggedIn = true;
//     }
//   }, []);

//   const handleLogout = () => {
//     // Perform logout actions
//     onLogout();
//     setShowLogoutToast(true);
//     // Hide the toast after 3 seconds
//     setTimeout(() => {
//       setShowLogoutToast(false);
//       // Clear login status from sessionStorage
//       sessionStorage.setItem('isLoggedIn', 'false');
//     }, 3000);
//   };

//   return (
//     <div className={`container-fluid ${scrolled ? "bg-light" : ""}`}>
//       <div className="container ">
//         <nav
//         style={{
//           paddingLeft: scrolled? "5vw":"0px"
//         }}
//           className={`navbar navbar-expand-lg navbar-light ${scrolled ? "fixed-top  bg-white" : "bg-black"
//             }`}
//         >
//           {/* <Link to="/home" className="navbar-brand">
//             <img src="./img/Cad_desk.png" height={50} width={200} alt="Logo" />
//           </Link>

//           <Link to="/home" className="navbar-brand">
//             <img src="./img/it_desk.jpeg" height={50} width={200} alt="Logo" />
//           </Link> */}
//           {/* 
//           <div className="d-flex align-items-center">
//             <Link to="/home" className="navbar-brand mb-0">
//               <img
//                 src="./img/Cad_desk.png"
//                 className="img-fluid"
//                 style={{ maxHeight: "50px" }}
//                 alt="CAD Desk Logo"
//               />
//             </Link>

//             <Link to="/home" className="navbar-brand mb-0 ms-2">
//               <img
//                 src="./img/it_desk.jpeg"
//                 className="img-fluid"
//                 style={{ maxHeight: "45px" }}
//                 alt="IT Desk Logo"
//               />
//             </Link>
//           </div> */}

//           <div className="d-flex align-items-center">

      
//             <Link to="/home" className="p-0 m-0">
//               <img
//                  src="./img/Rivara.JPEG"
//                 alt="CAD Desk Logo"
//                 style={{
//                   height: "6rem",
//                   display: "block"
//                 }}
//               />
//             </Link>

          
//             {/* <Link to="/home" className="p-0 m-0 ms-2">
//               <img
//                 src="./img/it_desk_1.png"
//                 alt="IT Desk Logo"
//                 style={{
//                   height: "45px",
//                   display: "block",
//                    mixBlendMode: "multiply",
//                    background:"transparent"
//                 }}
//               />
//             </Link> */}
//             <Link to="/home" className="p-0 m-0 ms-2">
// <Link to="/home" className="p-0 m-0 ">
//   <img
   

//      src="./img/Cad_desk.png"
//     alt="IT Desk Logo"
//     style={{
//       height: "45px",
//       display: "block"
//     }}
//   />
// </Link>

// </Link>


//           </div>


//           <button
//             className="navbar-toggler bg-primary"
//             type="button"
//             onClick={handleNavbarToggle}
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div
//             className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`}>

//             <div className="navbar-nav ml-auto">
//               <Link
//                 to="/"
//                 className="nav-item nav-link active myhome"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Home
//               </Link>
//               <Link
//                 to="/AboutUs"
//                 className="nav-item nav-link "
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 About
//               </Link>
//               <Link
//                 to="/Courses"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Courses
//               </Link>
//               <Link
//                 to="/Onlinecourses"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//               OnlinePrograms
//               </Link>
//               <Link
//                 to="/Contact"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Contact
//               </Link>

//               <span  className="nav-item nav-link navbar-nav ml-5" >
//                 {isLoggedIn ? (
//                   <a href="#" class="user-account" onClick={handleLogout}>
//                     <i class="fa-solid fa-sign-out"></i> Logout
//                   </a>
//                 ) : (
//                   <Link to="/Login"  className="user-account" style={{fontSize:"13px"}}>
//                     <span><i className="fa-solid fa-user-tie"></i></span><span>Login/Register</span>
//                   </Link>
//                 )}
//               </span>

//               {showLogoutToast && (
//                 <div className="logout-toast" style={{ position: 'fixed', top: '10px', right: '10px', backgroundColor: 'rgba(0, 0, 0, 0.7)', color: 'white', padding: '10px', borderRadius: '5px' }}>
//                   Logout successful
//                 </div>
//               )}
//               {/* <Link
//                 to="/dashboard"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Dashboard
//               </Link> */}
//               {isAdmin && (


//                 <Link to="/dashboard" style={{ width: "20px", marginTop: "6px", marginLeft: "10px" }}>
//                   <b>ADMIN</b>
//                 </Link>

//               )}
//             </div>
//           </div>
//         </nav>
//       </div>
//     </div>
//   );
// }

// export default NavBar;












// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// const word = 20;

// function NavBar({ isAdmin, onLogout, isLoggedIn }) {
//   const [scrolled, setScrolled] = useState(false);
//   const [isNavbarOpen, setIsNavbarOpen] = useState(false);
//   const [showLogoutToast, setShowLogoutToast] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 100);
//     const handleResize = () => setIsMobile(window.innerWidth < 992);
//     window.addEventListener("scroll", handleScroll);
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const userLoggedIn = sessionStorage.getItem('isLoggedIn');
//     if (userLoggedIn === 'true') {
//       isLoggedIn = true;
//     }
//   }, []);

//   const handleNavbarToggle = () => setIsNavbarOpen(!isNavbarOpen);
//   const closeNavbar = () => setIsNavbarOpen(false);

//   const handleLogout = () => {
//     onLogout();
//     setShowLogoutToast(true);
//     setTimeout(() => {
//       setShowLogoutToast(false);
//       sessionStorage.setItem('isLoggedIn', 'false');
//     }, 3000);
//   };

//   // Responsive logo sizes
//   const rivaraHeight  = isMobile ? "77px" : "99px";
//   const cadDeskHeight = isMobile ? "38px" : "48px";
//   const logoWrapH     = isMobile ? "50px" : "70px";

//   return (
//     <div className={`container-fluid ${scrolled ? "bg-light" : ""}`}>
//       <div className="container">
//         <nav
//           style={{
//             paddingLeft: scrolled ? "5vw" : "0px",
//             paddingTop: "0px",
//             paddingBottom: "0px",
//           }}
//           className={`navbar navbar-expand-lg navbar-light ${
//             scrolled ? "fixed-top bg-white" : "bg-black"
//           }`}
//         >
//           {/* Logo wrapper — height locked, logos clip inside */}
//           <div
//             className="d-flex align-items-center navbar-brand p-0 m-0"
//             style={{
//               height: logoWrapH,
//               overflow: "hidden",
//               flexShrink: 0,
//             }}
//           >
//             <Link
//               to="/home"
//               className="p-0 m-0"
//               style={{
//                 height: logoWrapH,
//                 overflow: "hidden",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src="./img/Rivara.JPEG"
//                 alt="Rivara Logo"
//                 style={{
//                   height: rivaraHeight,
//                   width: "auto",
//                   display: "block",
//                   transition: "height 0.2s",
//                 }}
//               />
//             </Link>

//             <Link
//               to="/home"
//               className="p-0 m-0 ms-2"
//               style={{
//                 height: logoWrapH,
//                 overflow: "hidden",
//                 display: "flex",
//                 alignItems: "center",
//               }}
//             >
//               <img
//                 src="./img/Cad_desk.png"
//                 alt="CAD Desk Logo"
//                 style={{
//                   height: cadDeskHeight,
//                   width: "auto",
//                   display: "block",
//                   transition: "height 0.2s",
//                 }}
//               />
//             </Link>
//           </div>

//           {/* Hamburger — stays on same line as logos on mobile */}
//           <button
//             className="navbar-toggler bg-primary ms-auto"
//             type="button"
//             onClick={handleNavbarToggle}
//             aria-expanded={isNavbarOpen}
//             aria-label="Toggle navigation"
//             style={{ flexShrink: 0 }}
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           {/* Nav links */}
//           <div className={`collapse navbar-collapse ${isNavbarOpen ? "show" : ""}`}>
//             <div className="navbar-nav ml-auto">
//               <Link
//                 to="/"
//                 className="nav-item nav-link active myhome"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Home
//               </Link>
//               <Link
//                 to="/AboutUs"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 About
//               </Link>
//               <Link
//                 to="/Courses"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Courses
//               </Link>
//               <Link
//                 to="/Onlinecourses"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 OnlinePrograms
//               </Link>
//               <Link
//                 to="/Contact"
//                 className="nav-item nav-link"
//                 onClick={closeNavbar}
//                 style={{ marginRight: word }}
//               >
//                 Contact
//               </Link>

//               <span className="nav-item nav-link navbar-nav ml-5">
//                 {isLoggedIn ? (
//                   <a href="#" className="user-account" onClick={handleLogout}>
//                     <i className="fa-solid fa-sign-out"></i> Logout
//                   </a>
//                 ) : (
//                   <Link to="/Login" className="user-account" style={{ fontSize: "13px" }}>
//                     <span><i className="fa-solid fa-user-tie"></i></span>
//                     <span>Login/Register</span>
//                   </Link>
//                 )}
//               </span>

//               {isAdmin && (
//                 <Link
//                   to="/dashboard"
//                   onClick={closeNavbar}
//                   style={{ width: "20px", marginTop: "6px", marginLeft: "10px" }}
//                 >
//                   <b>ADMIN</b>
//                 </Link>
//               )}
//             </div>
//           </div>
//         </nav>

//         {showLogoutToast && (
//           <div
//             style={{
//               position: "fixed",
//               top: "10px",
//               right: "10px",
//               backgroundColor: "rgba(0, 0, 0, 0.7)",
//               color: "white",
//               padding: "10px",
//               borderRadius: "5px",
//               zIndex: 9999,
//             }}
//           >
//             Logout successful
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NavBar;


// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// function NavBar({ isAdmin, onLogout, isLoggedIn }) {
//   const [scrolled, setScrolled] = useState(false);
//   const [isNavbarOpen, setIsNavbarOpen] = useState(false);
//   const [showLogoutToast, setShowLogoutToast] = useState(false);

//   const getDeviceType = () => {
//     const w = window.innerWidth;
//     if (w < 768) return "mobile";
//     if (w < 1200) return "tablet";
//     return "desktop";
//   };

//   const [deviceType, setDeviceType] = useState(getDeviceType());

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 100);
//     const handleResize = () => setDeviceType(getDeviceType());
//     window.addEventListener("scroll", handleScroll);
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const userLoggedIn = sessionStorage.getItem("isLoggedIn");
//     if (userLoggedIn === "true") {
//       isLoggedIn = true;
//     }
//   }, []);

//   const handleNavbarToggle = () => setIsNavbarOpen(!isNavbarOpen);
//   const closeNavbar = () => setIsNavbarOpen(false);

//   const handleLogout = () => {
//     onLogout();
//     setShowLogoutToast(true);
//     setTimeout(() => {
//       setShowLogoutToast(false);
//       sessionStorage.setItem("isLoggedIn", "false");
//     }, 3000);
//   };

//   // Logo sizes per device
//   const sizes = {
//     mobile:  { rivara: "77px", cadDesk: "38px", wrap: "50px" },
//     tablet:  { rivara: "55px", cadDesk: "44px", wrap: "60px" },
//     desktop: { rivara: "99px", cadDesk: "48px", wrap: "70px" },
//   };

//   // Nav link font & spacing per device
//   const navStyle = {
//     mobile:  { fontSize: "14px", gap: "2px" },
//     tablet:  { fontSize: "12px", gap: "2px" },
//     desktop: { fontSize: "14px", gap: "8px" },
//   };

//   const { rivara: rivaraHeight, cadDesk: cadDeskHeight, wrap: logoWrapH } = sizes[deviceType];
//   const { fontSize: linkFontSize, gap: linkGap } = navStyle[deviceType];

//   const isMobile = deviceType === "mobile";

//   return (
//     <div className={`container-fluid ${scrolled ? "bg-light" : ""}`}>
//       <div className="container-fluid px-0">
//         <nav
//           style={{
//             paddingLeft: scrolled ? "5vw" : "1rem",
//             paddingRight: "1rem",
//             paddingTop: "0px",
//             paddingBottom: "0px",
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "nowrap",        // never wrap on tablet/desktop
//           }}
//           // Only collapse to hamburger on mobile (< 768px)
//           className={`navbar navbar-expand-sm navbar-light ${
//             scrolled ? "fixed-top bg-white" : "bg-black"
//           }`}
//         >
//           {/* ── Logo wrapper ── */}
//           <div
//             className="d-flex align-items-center navbar-brand p-0 m-0"
//             style={{ height: logoWrapH, overflow: "hidden", flexShrink: 0 }}
//           >
//             <Link
//               to="/home"
//               className="p-0 m-0"
//               style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="./img/Rivara.JPEG"
//                 alt="Rivara Logo"
//                 style={{ height: rivaraHeight, width: "auto", display: "block", transition: "height 0.2s" }}
//               />
//             </Link>

//             <Link
//               to="/home"
//               className="p-0 m-0 ms-2"
//               style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="./img/Cad_desk.png"
//                 alt="CAD Desk Logo"
//                 style={{ height: cadDeskHeight, width: "auto", display: "block", transition: "height 0.2s" }}
//               />
//             </Link>
//           </div>

//           {/* ── Hamburger: only on mobile ── */}
//           {isMobile && (
//             <button
//               className="navbar-toggler bg-primary ms-auto"
//               type="button"
//               onClick={handleNavbarToggle}
//               aria-expanded={isNavbarOpen}
//               aria-label="Toggle navigation"
//               style={{ flexShrink: 0 }}
//             >
//               <span className="navbar-toggler-icon"></span>
//             </button>
//           )}

//           {/* ── Nav links ──
//               - Mobile: collapsible dropdown
//               - Tablet + Desktop: always visible inline  ── */}
//           <div
//             style={
//               isMobile
//                 ? {}  // let Bootstrap handle collapse on mobile
//                 : {   // tablet & desktop: always show inline
//                     display: "flex",
//                     flex: 1,
//                     justifyContent: "flex-end",
//                     alignItems: "center",
//                     flexWrap: "nowrap",
//                     overflow: "hidden",
//                   }
//             }
//             className={isMobile ? `collapse navbar-collapse ${isNavbarOpen ? "show" : ""}` : ""}
//           >
//             <div
//               className="navbar-nav"
//               style={{
//                 flexDirection: "row",
//                 flexWrap: "nowrap",
//                 alignItems: "center",
//                 gap: linkGap,
//                 ...(isMobile && isNavbarOpen
//                   ? {
//                       flexDirection: "column",
//                       alignItems: "flex-start",
//                       backgroundColor: scrolled ? "#fff" : "#000",
//                       padding: "10px",
//                       width: "100%",
//                     }
//                   : {}),
//               }}
//             >
//               {[
//                 { to: "/", label: "Home", extra: "active myhome" },
//                 { to: "/AboutUs", label: "About" },
//                 { to: "/Courses", label: "Courses" },
//                 { to: "/Onlinecourses", label: "OnlinePrograms" },
//                 { to: "/Contact", label: "Contact" },
//               ].map(({ to, label, extra = "" }) => (
//                 <Link
//                   key={to}
//                   to={to}
//                   className={`nav-item nav-link ${extra}`}
//                   onClick={closeNavbar}
//                   style={{ fontSize: linkFontSize, whiteSpace: "nowrap", padding: "4px 6px" }}
//                 >
//                   {label}
//                 </Link>
//               ))}

//               <span className="nav-item nav-link" style={{ whiteSpace: "nowrap", padding: "4px 6px" }}>
//                 {isLoggedIn ? (
//                   <a href="#" className="user-account" onClick={handleLogout} style={{ fontSize: linkFontSize }}>
//                     <i className="fa-solid fa-sign-out"></i> Logout
//                   </a>
//                 ) : (
//                   <Link
//                     to="/Login"
//                     className="user-account"
//                     style={{ fontSize: linkFontSize }}
//                     onClick={closeNavbar}
//                   >
//                     <i className="fa-solid fa-user-tie"></i> Login/Register
//                   </Link>
//                 )}
//               </span>

//               {isAdmin && (
//                 <Link
//                   to="/dashboard"
//                   onClick={closeNavbar}
//                   style={{ fontSize: linkFontSize, whiteSpace: "nowrap", marginLeft: "6px" }}
//                 >
//                   <b>ADMIN</b>
//                 </Link>
//               )}
//             </div>
//           </div>
//         </nav>

//         {/* ── Logout toast ── */}
//         {showLogoutToast && (
//           <div
//             style={{
//               position: "fixed",
//               top: "10px",
//               right: "10px",
//               backgroundColor: "rgba(0,0,0,0.7)",
//               color: "white",
//               padding: "10px",
//               borderRadius: "5px",
//               zIndex: 9999,
//             }}
//           >
//             Logout successful
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NavBar;
















// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// function NavBar({ isAdmin, onLogout, isLoggedIn }) {
//   const [scrolled, setScrolled] = useState(false);
//   const [isNavbarOpen, setIsNavbarOpen] = useState(false);
//   const [showLogoutToast, setShowLogoutToast] = useState(false);

//   const getDeviceType = () => {
//     const w = window.innerWidth;
//     if (w < 768) return "mobile";
//     if (w < 1200) return "tablet";
//     return "desktop";
//   };

//   const [deviceType, setDeviceType] = useState(getDeviceType());

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 100);
//     const handleResize = () => setDeviceType(getDeviceType());
//     window.addEventListener("scroll", handleScroll);
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   useEffect(() => {
//     const userLoggedIn = sessionStorage.getItem("isLoggedIn");
//     if (userLoggedIn === "true") {
//       isLoggedIn = true;
//     }
//   }, []);

//   const handleNavbarToggle = () => setIsNavbarOpen(!isNavbarOpen);
//   const closeNavbar = () => setIsNavbarOpen(false);

//   const handleLogout = () => {
//     onLogout();
//     setShowLogoutToast(true);
//     setTimeout(() => {
//       setShowLogoutToast(false);
//       sessionStorage.setItem("isLoggedIn", "false");
//     }, 3000);
//   };

//   // Logo sizes per device
//   const sizes = {
//     mobile:  { rivara: "77px", cadDesk: "38px", wrap: "50px" },
//     tablet:  { rivara: "55px", cadDesk: "44px", wrap: "60px" },
//     desktop: { rivara: "99px", cadDesk: "48px", wrap: "70px" },
//   };

//   // Nav link font & spacing per device
//   const navStyle = {
//     mobile:  { fontSize: "14px", gap: "2px" },
//     tablet:  { fontSize: "12px", gap: "2px" },
//     desktop: { fontSize: "14px", gap: "8px" },
//   };

//   const { rivara: rivaraHeight, cadDesk: cadDeskHeight, wrap: logoWrapH } = sizes[deviceType];
//   const { fontSize: linkFontSize, gap: linkGap } = navStyle[deviceType];

//   const isMobile = deviceType === "mobile";

//   const navLinks = [
//     { to: "/",              label: "Home",          extra: "active myhome" },
//     { to: "/AboutUs",       label: "About" },
//     { to: "/Courses",       label: "Courses" },
//     { to: "/Onlinecourses", label: "OnlinePrograms" },
//     { to: "/Contact",       label: "Contact" },
//   ];

//   return (
//     // Using position:relative on outer div so mobile dropdown positions correctly below navbar
//     <div className={`container-fluid ${scrolled ? "bg-light" : ""}`} style={{ position: "relative" }}>
//       <div className="container-fluid px-0">
//         <nav
//           style={{
//             paddingLeft: scrolled ? "5vw" : "1rem",
//             paddingRight: "1rem",
//             paddingTop: "0px",
//             paddingBottom: "0px",
//             display: "flex",
//             alignItems: "center",
//             flexWrap: "nowrap",
//           }}
//           className={`navbar navbar-expand-sm navbar-light ${
//             scrolled ? "fixed-top bg-white" : "bg-black"
//           }`}
//         >
//           {/* ── Logo wrapper ── */}
//           <div
//             className="d-flex align-items-center navbar-brand p-0 m-0"
//             style={{ height: logoWrapH, overflow: "hidden", flexShrink: 0 }}
//           >
//             <Link
//               to="/home"
//               className="p-0 m-0"
//               style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="./img/Rivara.JPEG"
//                 alt="Rivara Logo"
//                 style={{ height: rivaraHeight, width: "auto", display: "block", transition: "height 0.2s" }}
//               />
//             </Link>

//             <Link
//               to="/home"
//               className="p-0 m-0 ms-2"
//               style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
//             >
//               <img
//                 src="./img/Cad_desk.png"
//                 alt="CAD Desk Logo"
//                 style={{ height: cadDeskHeight, width: "auto", display: "block", transition: "height 0.2s" }}
//               />
//             </Link>
//           </div>

//           {/* ── Hamburger: only on mobile ── */}
//           {isMobile && (
//             <button
//               className="navbar-toggler bg-primary ms-auto"
//               type="button"
//               onClick={handleNavbarToggle}
//               aria-expanded={isNavbarOpen}
//               aria-label="Toggle navigation"
//               style={{ flexShrink: 0 }}
//             >
//               <span className="navbar-toggler-icon"></span>
//             </button>
//           )}

//           {/* ── Tablet & Desktop: always visible inline ── */}
//           {!isMobile && (
//             <div
//               style={{
//                 display: "flex",
//                 flex: 1,
//                 justifyContent: "flex-end",
//                 alignItems: "center",
//                 flexWrap: "nowrap",
//                 overflow: "hidden",
//                 gap: linkGap,
//               }}
//             >
//               <div
//                 className="navbar-nav"
//                 style={{ flexDirection: "row", flexWrap: "nowrap", alignItems: "center", gap: linkGap }}
//               >
//                 {navLinks.map(({ to, label, extra = "" }) => (
//                   <Link
//                     key={to}
//                     to={to}
//                     className={`nav-item nav-link ${extra}`}
//                     onClick={closeNavbar}
//                     style={{ fontSize: linkFontSize, whiteSpace: "nowrap", padding: "4px 6px" }}
//                   >
//                     {label}
//                   </Link>
//                 ))}

//                 <span className="nav-item nav-link" style={{ whiteSpace: "nowrap", padding: "4px 6px" }}>
//                   {isLoggedIn ? (
//                     <a href="#" className="user-account" onClick={handleLogout} style={{ fontSize: linkFontSize }}>
//                       <i className="fa-solid fa-sign-out"></i> Logout
//                     </a>
//                   ) : (
//                     <Link
//                       to="/Login"
//                       className="user-account"
//                       style={{ fontSize: linkFontSize }}
//                       onClick={closeNavbar}
//                     >
//                       <i className="fa-solid fa-user-tie"></i> Login/Register
//                     </Link>
//                   )}
//                 </span>

//                 {isAdmin && (
//                   <Link
//                     to="/dashboard"
//                     onClick={closeNavbar}
//                     style={{ fontSize: linkFontSize, whiteSpace: "nowrap", marginLeft: "6px" }}
//                   >
//                     <b>ADMIN</b>
//                   </Link>
//                 )}
//               </div>
//             </div>
//           )}
//         </nav>

//         {/* ── Mobile dropdown: renders BELOW navbar, full width, left-aligned ── */}
//         {isMobile && isNavbarOpen && (
//           <div
//             style={{
//               position: "absolute",
//               top: "100%",        // sits right below the navbar
//               left: 0,
//               right: 0,
//               backgroundColor: "#ffffff",
//               zIndex: 1050,
//               padding: "8px 0",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//             }}
//           >
//             {navLinks.map(({ to, label, extra = "" }) => (
//               <Link
//                 key={to}
//                 to={to}
//                 className={`nav-link ${extra}`}
//                 onClick={closeNavbar}
//                 style={{
//                   display: "block",
//                   fontSize: "15px",
//                   padding: "10px 20px",
//                   color: "#000000",
//                   borderBottom: "1px solid rgba(0,0,0,0.06)",
//                   textAlign: "left",
//                 }}
//               >
//                 {label}
//               </Link>
//             ))}

//             {/* Login/Logout */}
//             <div style={{ padding: "10px 20px", borderBottom: "1px solid rgba(0,0,0,0.06)" }}>
//               {isLoggedIn ? (
//                 <a
//                   href="#"
//                   className="user-account"
//                   onClick={handleLogout}
//                   style={{ fontSize: "15px", color: "#000000" }}
//                 >
//                   <i className="fa-solid fa-sign-out"></i> Logout
//                 </a>
//               ) : (
//                 <Link
//                   to="/Login"
//                   className="user-account"
//                   onClick={closeNavbar}
//                   style={{ fontSize: "15px", color: "#d4a017" /* keeps your orange Login color */ }}
//                 >
//                   <i className="fa-solid fa-user-tie"></i> Login/Register
//                 </Link>
//               )}
//             </div>

//             {isAdmin && (
//               <Link
//                 to="/dashboard"
//                 onClick={closeNavbar}
//                 style={{ display: "block", fontSize: "15px", padding: "10px 20px", color: "#000000" }}
//               >
//                 <b>ADMIN</b>
//               </Link>
//             )}
//           </div>
//         )}

//         {/* ── Logout toast ── */}
//         {showLogoutToast && (
//           <div
//             style={{
//               position: "fixed",
//               top: "10px",
//               right: "10px",
//               backgroundColor: "rgba(0,0,0,0.7)",
//               color: "white",
//               padding: "10px",
//               borderRadius: "5px",
//               zIndex: 9999,
//             }}
//           >
//             Logout successful
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default NavBar;




import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function NavBar({ isAdmin, onLogout, isLoggedIn }) {
  const [scrolled, setScrolled] = useState(false);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [showLogoutToast, setShowLogoutToast] = useState(false);

  const getDeviceType = () => {
    const w = window.innerWidth;
    if (w < 768) return "mobile";
    if (w < 1200) return "tablet";
    return "desktop";
  };

  const [deviceType, setDeviceType] = useState(getDeviceType());

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 100);
    const handleResize = () => setDeviceType(getDeviceType());
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const userLoggedIn = sessionStorage.getItem("isLoggedIn");
    if (userLoggedIn === "true") {
      isLoggedIn = true;
    }
  }, []);

  const handleNavbarToggle = () => setIsNavbarOpen(!isNavbarOpen);
  const closeNavbar = () => setIsNavbarOpen(false);

  const handleLogout = () => {
    onLogout();
    setShowLogoutToast(true);
    setTimeout(() => {
      setShowLogoutToast(false);
      sessionStorage.setItem("isLoggedIn", "false");
    }, 3000);
  };

  // Logo sizes per device
  const sizes = {
    mobile:  { rivara: "77px", cadDesk: "38px", wrap: "50px" },
    tablet:  { rivara: "95px", cadDesk: "44px", wrap: "60px" },
    desktop: { rivara: "99px", cadDesk: "48px", wrap: "70px" },
  };

  // Nav link font & spacing per device
  const navStyle = {
    mobile:  { fontSize: "14px", gap: "2px" },
    tablet:  { fontSize: "12px", gap: "2px" },
    desktop: { fontSize: "14px", gap: "8px" },
  };

  const { rivara: rivaraHeight, cadDesk: cadDeskHeight, wrap: logoWrapH } = sizes[deviceType];
  const { fontSize: linkFontSize, gap: linkGap } = navStyle[deviceType];

  const isMobile = deviceType === "mobile";

  const navLinks = [
    { to: "/",              label: "Home",          extra: "active myhome" },
    { to: "/AboutUs",       label: "About" },
    { to: "/Courses",       label: "Courses" },
    { to: "/Onlinecourses", label: "OnlinePrograms" },
    { to: "/Contact",       label: "Contact" },
  ];

  return (
    // Using position:relative on outer div so mobile dropdown positions correctly below navbar
    <div className={`container-fluid ${scrolled ? "bg-light" : ""}`} style={{ position: "relative" }}>
      <div className="container-fluid px-0">
        <nav
          style={{
            paddingLeft: scrolled ? "5vw" : "1rem",
            paddingRight: "1rem",
            paddingTop: "0px",
            paddingBottom: "0px",
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
          }}
          className={`navbar navbar-expand-sm navbar-light ${
            scrolled ? "fixed-top bg-white" : "bg-black"
          }`}
        >
          {/* ── Logo wrapper ── */}
          <div
            className="d-flex align-items-center navbar-brand p-0 m-0"
            style={{ height: logoWrapH, overflow: "hidden", flexShrink: 0 }}
          >
            <Link
              to="/home"
              className="p-0 m-0"
              style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
            >
              <img
                src="./img/Rivara.JPEG"
                alt="Rivara Logo"
                style={{ height: rivaraHeight, width: "auto", display: "block", transition: "height 0.2s" }}
              />
            </Link>

            <Link
              to="/home"
              className="p-0 m-0 ms-2"
              style={{ height: logoWrapH, overflow: "hidden", display: "flex", alignItems: "center" }}
            >
              <img
                src="./img/Cad_desk.png"
                alt="CAD Desk Logo"
                style={{ height: cadDeskHeight, width: "auto", display: "block", transition: "height 0.2s" }}
              />
            </Link>
          </div>

          {/* ── Hamburger: only on mobile ── */}
          {isMobile && (
            <button
              className="navbar-toggler bg-primary ms-auto"
              type="button"
              onClick={handleNavbarToggle}
              aria-expanded={isNavbarOpen}
              aria-label="Toggle navigation"
              style={{ flexShrink: 0 }}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          )}

          {/* ── Tablet & Desktop: always visible inline ── */}
          {!isMobile && (
            <div
              style={{
                display: "flex",
                flex: 1,
                justifyContent: "flex-end",
                alignItems: "center",
                flexWrap: "nowrap",
                overflow: "hidden",
                gap: linkGap,
              }}
            >
              <div
                className="navbar-nav"
                style={{ flexDirection: "row", flexWrap: "nowrap", alignItems: "center", gap: linkGap }}
              >
                {navLinks.map(({ to, label, extra = "" }) => (
                  <Link
                    key={to}
                    to={to}
                    className={`nav-item nav-link ${extra}`}
                    onClick={closeNavbar}
                    style={{ fontSize: linkFontSize, whiteSpace: "nowrap", padding: "4px 6px" }}
                  >
                    {label}
                  </Link>
                ))}

                <span className="nav-item nav-link" style={{ whiteSpace: "nowrap", padding: "4px 6px" }}>
                  {isLoggedIn ? (
                    <a href="#" className="user-account" onClick={handleLogout} style={{ fontSize: linkFontSize }}>
                      <i className="fa-solid fa-sign-out"></i> Logout
                    </a>
                  ) : (
                    <Link
                      to="/Login"
                      className="user-account"
                      style={{ fontSize: linkFontSize }}
                      onClick={closeNavbar}
                    >
                      <i className="fa-solid fa-user-tie"></i> Login/Register
                    </Link>
                  )}
                </span>

                {isAdmin && (
                  <Link
                    to="/dashboard"
                    onClick={closeNavbar}
                    style={{ fontSize: linkFontSize, whiteSpace: "nowrap", marginLeft: "6px" }}
                  >
                    <b>ADMIN</b>
                  </Link>
                )}
              </div>
            </div>
          )}
        </nav>

        {/* ── Mobile dropdown: renders BELOW navbar, full width, left-aligned ── */}
        {isMobile && isNavbarOpen && (
          <div
            style={{
              position: "absolute",
              top: "100%",        // sits right below the navbar
              left: 0,
              right: 0,
              backgroundColor: "#ffffff",
              zIndex: 1050,
              padding: "8px 0",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            {navLinks.map(({ to, label, extra = "" }) => (
              <Link
                key={to}
                to={to}
                className={`nav-link ${extra}`}
                onClick={closeNavbar}
                style={{
                  display: "block",
                  fontSize: "15px",
                  fontWeight: "500",        // ← bold text
                 padding: "3px 20px",
     // ← reduced height
                  color: "#000000",
                  borderBottom: "1px solid rgba(0,0,0,0.06)",
                  textAlign: "left",
                }}
              >
                {label}
              </Link>
            ))}

            {/* Login/Logout */}
            <div style={{ padding: "3px 20px", borderBottom: "1px solid rgba(0,0,0,0.06)" }}
>
              {isLoggedIn ? (
                <a
                  href="#"
                  className="user-account"
                  onClick={handleLogout}
                  style={{ fontSize: "15px", fontWeight: "600", color: "#000000" }}
                >
                  <i className="fa-solid fa-sign-out"></i> Logout
                </a>
              ) : (
                <Link
                  to="/Login"
                  className="user-account"
                  onClick={closeNavbar}
                  style={{ fontSize: "15px", fontWeight: "600", color: "#d4a017" }}
                >
                  <i className="fa-solid fa-user-tie"></i> Login/Register
                </Link>
              )}
            </div>

            {isAdmin && (
              <Link
                to="/dashboard"
                onClick={closeNavbar}
              style={{ display: "block", fontSize: "15px", padding: "3px 20px", color: "#000000" }}

              >
                <b>ADMIN</b>
              </Link>
            )}
          </div>
        )}

        {/* ── Logout toast ── */}
        {showLogoutToast && (
          <div
            style={{
              position: "fixed",
              top: "10px",
              right: "10px",
              backgroundColor: "rgba(0,0,0,0.7)",
              color: "white",
              padding: "10px",
              borderRadius: "5px",
              zIndex: 9999,
            }}
          >
            Logout successful
          </div>
        )}
      </div>
    </div>
  );
}

export default NavBar;